import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box, Text, Flex } from "orcs-design-system";

const QueryBlock = styled(Box)`
  background: #1e1e2e;
  color: #cdd6f4;
  border-radius: 6px;
  padding: 12px;
  font-family: "SF Mono", "Fira Code", "Consolas", monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
  position: relative;
`;

const CopyButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #cdd6f4;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const CaveatBadge = styled(Text)`
  background: #fff3cd;
  color: #856404;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
`;

const GqlExpertResponse = ({ content }) => {
  let parsed;
  try {
    parsed = JSON.parse(content);
  } catch {
    // Not valid JSON — fall back to plain text
    return <Text fontSize="14px">{content}</Text>;
  }

  const { explanation, suggested_queries: queries } = parsed;

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Flex flexDirection="column" gap="r">
      {explanation && (
        <Text fontSize="14px" color="bodyText" lineHeight="1.5">
          {explanation}
        </Text>
      )}

      {queries?.map((q, i) => (
        <Box
          key={`query-${q.description?.slice(0, 30) || i}`}
          border="1px solid"
          borderColor="surfaceBorder"
          borderRadius="8px"
          padding="r"
        >
          <Flex justifyContent="space-between" alignItems="flex-start" mb="s">
            <Text fontWeight="600" fontSize="14px" color="bodyText">
              {i + 1}. {q.description}
            </Text>
          </Flex>

          <QueryBlock>
            <CopyButton onClick={() => handleCopy(q.query)}>Copy</CopyButton>
            {q.query}
          </QueryBlock>

          {q.caveats && (
            <Box mt="s">
              <CaveatBadge>⚠ {q.caveats}</CaveatBadge>
            </Box>
          )}
        </Box>
      ))}
    </Flex>
  );
};

GqlExpertResponse.propTypes = {
  content: PropTypes.string.isRequired,
};

export default GqlExpertResponse;
